//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import wrapCsvValue from "../../mixins/wrapCsvValue";
import { date } from "quasar";
import router from "../../router";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
      },
      columns: [
        {
          name: "UserId",
          align: "left",
          label: this.$t("users.id"),
          field: "userId",
          sortable: true,
        },
        {
          name: "Username",
          align: "left",
          label: this.$t("users.name"),
          field: "userName",
          sortable: true,
        },
      ],
      filter: "",
      users: [],
    };
  },

  computed: {},

  methods: {
    async refresh() {
     
      this.users = await this.getUsers();
    },
    newUser() {
     
      router.push({ name: "NewUser", params: { id: 0 } });
    },
    onRowClick(evt, row) {
    
    },

    ...mapActions("main", ["getUsers"]),
  },

  async created() {
  
    this.users = await this.getUsers();
  },
};
